import { ChangeDetectionStrategy, Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';

import { RouterService } from '@ecm/router';

import { CarrouselItemViewModelMapper } from '../../business/mapper/carrousel-item-view-model-mapper';
import { CarrouselItemViewModel } from '../../business/model/carrousel-item.view-model';
import { CarrouselStoreService } from '../../store/carrousel-store.service';
import { SelectedLink } from '../../store/nav-display-config';

@Component({
    selector: 'ecm-carrousel',
    templateUrl: 'carrousel.component.html',
    styleUrls: ['carrousel.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarrouselComponent {
    @Input() public isXlScreen: boolean;
    @ViewChildren('buttonRef') public buttonRefs: QueryList<ElementRef>;
    public isSosh = toSignal(this.routerService.isSosh$);
    public carrouselLinksItems: { type: string; selected: boolean }[];
    public carrouselItems$ = this.carrouselStore.items$;
    public isCustomerBenefits$ = this.carrouselStore.checkAncrageCustomerBenefits$;
    public isOrangeServices$ = this.carrouselStore.checkAncrageOrangeServices$;
    public contracts$ = this.carrouselStore.getOfferItems$;
    public carrouselLinksItemsSelected: boolean;

    protected selectedLink: SelectedLink = SelectedLink.EMPTY;
    protected readonly SelectedLink = SelectedLink;

    public constructor(
        protected route: ActivatedRoute,
        private carrouselStore: CarrouselStoreService,
        private routerService: RouterService,
        private carrouselItemViewModelMapper: CarrouselItemViewModelMapper,
    ) {
        combineLatest({
            selectedLink: this.carrouselStore.getDisplayConfig$.pipe(map((config) => config.selectedLink)),
            links: this.carrouselItemViewModelMapper.extractLinks(this.getIsSosh()),
        })
            .pipe(takeUntilDestroyed())
            .subscribe(({ selectedLink, links }) => {
                this.selectedLink = selectedLink;
                this.carrouselLinksItems = links.map((type) => ({
                    type,
                    selected: type.split('.').pop() === selectedLink,
                }));
                this.carrouselLinksItemsSelected = this.carrouselLinksItems.some((item) => item.selected);
            });
    }

    public select(item: CarrouselItemViewModel) {
        if (item.id) {
            this.carrouselStore.selectItem(item.id, true);
        }

        this.carrouselStore.openLink(item.button);
    }

    public selectContract(index: number, cid: string) {
        const button = this.buttonRefs.toArray()[index].nativeElement;
        button.scrollIntoView({ inline: 'center' });
        if (cid) {
            this.carrouselStore.selectItem(cid);
        }
    }

    public getIsSosh(): Observable<boolean> {
        return this.routerService.isCurrentRouteSosh();
    }
}
